var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00ADEF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.067v7.666h10.5V1.725zM12 1.533v9.2h12V0zM12 12.267v9.2L24 23V12.267zM0 12.267v7.666l10.5 1.342v-9.008z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowIconBlue);
export default __webpack_public_path__ + "static/media/window-icon-blue.84dd62b209097f25239daa8ade339c9a.svg";
export { ForwardRef as ReactComponent };